export default __webpack_public_path__ + "img/28275446d158ac99cd3b9cb362dfba2f.png";